import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import Asistencia from './paginas/AsistenciaDelCurso';
import HorarioCompleto from './paginas/HorarioCompleto';

type Props = RouteComponentProps<{}>;

const AsistenciaPrincipal: React.FunctionComponent<Props> = props => {
    const rutaBase = props.match.url;

    return (
        <Container>
            <Route
                exact
                path={rutaBase + '/cursos'}
                children={({ match }) => <HorarioCompleto oculto={!match} />}
            />

            <Switch>
                <Redirect exact from={rutaBase} to={rutaBase + '/cursos'} />
                <Route path={rutaBase + '/cursos/:id'} component={Asistencia} />
            </Switch>
        </Container>
    );
};

export default AsistenciaPrincipal;



// WEBPACK FOOTER //
// ./src/modulos/Asistencia/index.tsx